import React, {useEffect, useState} from 'react';
import {Modal, View, Text, Button, Platform, Switch, StyleSheet} from 'react-native';
import DateTimePicker from '@react-native-community/datetimepicker';
import {DateTimePickerAndroid} from '@react-native-community/datetimepicker'; // Import DateTimePickerAndroid
import styled from 'styled-components/native';

const daysOfWeek = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton,
    WorkoutCommonButtonTwo,
    WorkoutTextSubHeader
} from '../styles/common-styles';

function ReminderManager({
     modalVisible,
     setModalVisible,
     onSave,
     initialTime = "00:00",
     initialDays = [],
     editingMode
 }) {
    const [date, setDate] = useState(new Date());
    const [tempDate, setTempDate] = useState(new Date());
    const [selectedDays, setSelectedDays] = useState(
        daysOfWeek.reduce((acc, day) => ({...acc, [day]: initialDays.includes(day)}), {})
    );
    const [showPicker, setShowPicker] = useState(false);

    const convertTimeToDate = (timeString) => {
        const [hours, minutes] = timeString.split(':').map(Number);
        const time = new Date();
        time.setHours(hours, minutes, 0);
        return time;
    };

    useEffect(() => {
        if (editingMode) {
            setDate(convertTimeToDate(initialTime));
            setTempDate(convertTimeToDate(initialTime));
            setSelectedDays(
                daysOfWeek.reduce((acc, day) => ({...acc, [day]: initialDays.includes(day)}), {})
            );
        }

        if (initialTime === "00:00" && !editingMode) {
            setDate(convertTimeToDate(initialTime));
        }

        if (!editingMode) {
            setSelectedDays(
                daysOfWeek.reduce((acc, day) => ({...acc, [day]: false}), {})
            );
        }
    }, [initialDays, initialTime, editingMode]);

    const handleSave = () => {
        const daysToSave = Object.keys(selectedDays).filter(day => selectedDays[day]);
        onSave(date, daysToSave);
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    // Custom function to handle Android's DateTimePicker
    const showTimepicker = () => {
        DateTimePickerAndroid.open({
            value: date,
            onChange: (event, selectedDate) => {
                if (selectedDate) {
                    setDate(new Date(selectedDate)); // Directly update the main date
                    setShowPicker(false); // Close the picker right after selection
                }
            },
            mode: 'time',
            is24Hour: false
        });
    };

    const onChange = (event, selectedDate) => {
        const currentDate = selectedDate || tempDate;
        setTempDate(currentDate); // Temporarily store the selected date
    };

    const handleSaveChanges = () => {
        setDate(tempDate); // Update main date with the selected time from the picker
        setShowPicker(false); // Close the picker modal
    };

    const handleCancelChanges = () => {
        setShowPicker(false); // Close the picker modal without updating the main date
    };

    const formatTime = (date) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return `${hours}:${minutes} ${ampm}`;
    };

    const toggleDaySelection = (day) => {
        setSelectedDays(prev => ({...prev, [day]: !prev[day]}));
    };

    return (
        <Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => setModalVisible(!modalVisible)}
        >
            <ModalContainer>
                <ModalView>
                    <ModalText>CHOOSE TIME</ModalText>
                    <TimeDisplayParent onPress={Platform.OS === 'android' ? showTimepicker : () => setShowPicker(true)}>
                        <TimeDisplay>{formatTime(date)}</TimeDisplay>
                    </TimeDisplayParent>
                    {Platform.OS === 'ios' && (
                        <Modal
                            transparent={true}
                            animationType=""
                            visible={showPicker}
                            onRequestClose={() => setShowPicker(false)}
                        >
                            <View style={{
                                flex: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                width: '100%'
                            }}>
                                <View style={{
                                    backgroundColor: 'white',
                                    borderRadius: 20,
                                    padding: 5,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: 300
                                }}>
                                    <DateTimePicker
                                        testID="dateTimePicker"
                                        value={date}
                                        mode="time"
                                        is24Hour={true}
                                        display='spinner'
                                        onChange={onChange}
                                    />
                                    <TimePickerButtonParent>
                                        <ReminderCommonButtonTwo onPress={handleCancelChanges}>
                                            <ReminderCommonButtonTextTwo>CANCEL</ReminderCommonButtonTextTwo>
                                        </ReminderCommonButtonTwo>
                                        <ReminderCommonButton onPress={handleSaveChanges}>
                                            <ReminderCommonButtonText>SAVE</ReminderCommonButtonText>
                                        </ReminderCommonButton>
                                    </TimePickerButtonParent>
                                </View>
                            </View>
                        </Modal>
                    )}
                    <ModalText>SELECT DAYS</ModalText>
                    <DayListParent>
                        {daysOfWeek.map(day => (
                            <DayListItem key={day}
                                         style={{flexDirection: 'row', alignItems: 'center', marginVertical: 5}}>
                                <DayListText style={{marginRight: 10}}>{`EVERY ${day.toUpperCase()}`}</DayListText>
                                <Switch
                                    trackColor={{false: "#c3c5c7", true: "#9fd1bb"}}
                                    thumbColor={selectedDays[day] ? "#ffffff" : "#e8e9ea"}
                                    onValueChange={() => toggleDaySelection(day)}
                                    value={selectedDays[day]}
                                />
                            </DayListItem>
                        ))}
                    </DayListParent>
                    <ReminderButtonParent>
                        <ReminderCommonButtonTwo onPress={handleCancel}>
                            <ReminderCommonButtonTextTwo>CANCEL</ReminderCommonButtonTextTwo>
                        </ReminderCommonButtonTwo>
                        <ReminderCommonButton onPress={handleSave}>
                            <ReminderCommonButtonText>SAVE</ReminderCommonButtonText>
                        </ReminderCommonButton>
                    </ReminderButtonParent>
                </ModalView>
            </ModalContainer>
        </Modal>
    );
}

// Styled components for modal styling
const ModalContainer = styled.View`
  flex: 1;
  width: 100%;
  height: 100%;
  justify-content: center;
  alignItems: center;
  padding: 30px;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalView = styled.View`
  width: 100%;
  background-color: white;
  border-radius: 20px;
  padding: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;


export const ModalText = styled(WorkoutTextSubHeader)`
  font-family: 'Montserrat-EB';
  letter-spacing: 0.5px;
  text-align: left;
`

export const TimeDisplayParent = styled.TouchableOpacity`
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  borderBottomWidth: 1px;
  borderBottomColor: #e8e9ea;
  margin-bottom: 25px;
`

export const TimeDisplay = styled.Text`
  margin-top: -10px;
  font-size: 42px;
  color: #2d366e;
  font-family: 'Montserrat-EB';
`

const DayListParent = styled.View`
  width: 100%;
  margin-top: -10px;
`

const DayListItem = styled.View`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  borderBottomWidth: 1px;
  borderBottomColor: #e8e9ea;
  height: 50px;
  margin-bottom: -5px;

`
const DayListText = styled.Text`
  font-size: 16px;
  color: #2d366e;
  font-family: 'Montserrat-EB';
`

const ReminderButtonParent = styled.View`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin-top: 25px;
`

const TimePickerButtonParent = styled(ReminderButtonParent)`
  width: 90%;
  margin-bottom: 10px;
`

const ReminderCommonButton = styled(WorkoutCommonButton)`
  height: 35px;
  width: 125px;
  padding-left: 0;
  padding-right: 0;
`

const ReminderCommonButtonTwo = styled(ReminderCommonButton)`
  background: transparent;
  border: 2px solid #3366cc;
`

const ReminderCommonButtonText = styled.Text`
  font-family: 'Montserrat-SB';
  font-size: 13px;
  color: white;
  letter-spacing: 2px;
`

const ReminderCommonButtonTextTwo = styled(ReminderCommonButtonText)`
  color: #3366cc;
`

export default ReminderManager;
